// Approval Step Status
export enum ApprovalStepStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
}

export const getApprovalStepStatusTranslationKey = (
  approvalStepStatus: ApprovalStepStatus,
): string => {
  const translationKeys: {
    [key in ApprovalStepStatus]: string;
  } = {
    [ApprovalStepStatus.APPROVED]: 'laApproved',
    [ApprovalStepStatus.REJECTED]: 'laRejected',
    [ApprovalStepStatus.PENDING]: 'label_PENDING',
  };

  return translationKeys[approvalStepStatus];
};

// Proposal Status
export enum ProposalStatus {
  PROPOSED = 'PROPOSED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
}

export const getProposalStatusTranslationKey = (
  proposalStatus: ProposalStatus,
): string => {
  const translationKeys: {
    [key in ProposalStatus]: string;
  } = {
    [ProposalStatus.PROPOSED]: 'proposed',
    [ProposalStatus.IN_PROGRESS]: 'inProgress',
    [ProposalStatus.COMPLETED]: 'approved',
    [ProposalStatus.FAILED]: 'rejected',
    [ProposalStatus.CLOSED]: 'label_CLOSED',
    [ProposalStatus.DELETED]: 'laDeleted',
  };

  return translationKeys[proposalStatus];
};

// Proposal Type
export enum ProposalType {
  ALLOWANCE_PROPOSAL = 'ALLOWANCE_PROPOSAL',
  BENEFIT_PROPOSAL = 'BENEFIT_PROPOSAL',
  BILLABLE_HOURS = 'BILLABLE_HOURS',
  BONUS_PROPOSAL = 'BONUS_PROPOSAL',
  JOB_OPENING = 'JOB_OPENING',
  SALARY_PROPOSAL = 'SALARY_PROPOSAL',
  EMPLOYMENT_DETAILS_PROPOSAL = 'EMPLOYMENT_DETAILS_PROPOSAL',
  POSITION_INTERNAL_PROPOSAL = 'POSITION_INTERNAL_PROPOSAL',
}

export const getProposalTypeTranslationKey = (
  proposalType: ProposalType,
): string => {
  const translationKeys: {
    [key in ProposalType]: string;
  } = {
    [ProposalType.ALLOWANCE_PROPOSAL]: 'laAllowanceProposal',
    [ProposalType.BENEFIT_PROPOSAL]: 'laBenefitProposal',
    [ProposalType.BILLABLE_HOURS]: 'laBillableHoursProposal',
    [ProposalType.BONUS_PROPOSAL]: 'laShortTermIncentivesBonusProp',
    [ProposalType.JOB_OPENING]: 'laJobOpeningProposal',
    [ProposalType.SALARY_PROPOSAL]: 'laSalaryProposal',
    [ProposalType.EMPLOYMENT_DETAILS_PROPOSAL]: 'laEMPLOYMENT_DETAILS_PROPOSAL',
    [ProposalType.POSITION_INTERNAL_PROPOSAL]: 'laPOSITION_INTERNAL_PROPOSAL',
  };

  return translationKeys[proposalType];
};
